// extracted by mini-css-extract-plugin
export var menuIcon = "_ji-0";
export var menuIconInline = "_ji-1";